import { useState, useEffect } from "react";
const { XMLParser } = require("fast-xml-parser");

const useWMTSLayers = (wmtsUrl) => {
  const [layers, setLayers] = useState(null);
  const [wmtsLayers, setWMTSLayers] = useState("");
  const urlHttpRegexp = new RegExp(/^((http|https):\/\/)/);

  useEffect(() => {
    async function getWMTSLayers() {
      try {
        const response = await fetch(
          urlHttpRegexp.test(wmtsUrl) ? wmtsUrl : `https://${wmtsUrl}`
        );
        const text = await response.text();
        const parser = new XMLParser();
        const data = parser.parse(text);
        const layers = data?.Capabilities?.Contents?.Layer?.map(
          (layer, index) => {
            return {
              ...layer,
              name: layer["ows:Title"],
              parentLayerId: -1,
              id: index,
            };
          }
        );
        setLayers(layers);
        setWMTSLayers(text);
      } catch (err) {
        console.error(new Error("[OLMap] - could not fetch WMTS layers:", err));
      }
    }

    if (wmtsUrl) getWMTSLayers();
  }, [wmtsUrl]);

  return [layers || [], wmtsLayers];
};

export default useWMTSLayers;
